import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { map, tap } from 'rxjs/operators';
import { AuthService } from '../auth/auth-service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private auth: AuthService, private router: Router) { }

  canActivate() {
    return this.auth.isAdmin().pipe(
      tap(isAdmin => {
        if (!isAdmin) this.router.navigate(['/login']);
      })
    );
  }
}
